export type RouteName =
  | 'dashboard' | 'calendar' | 'enquiries' | 'bookings' | 'booking' | 'customers' | 'customer' | 'expenses' | 'expense'
  | 'reports' | 'stats' | 'about' | 'settings' | 'bill' | 'account' | 'new' | 'more';

export interface Route { name: RouteName; params: Record<string, string> }

export function parseHash(hash: string): Route {
  const h = hash.replace(/^#\/?/, '');
  const [name, q = ''] = h.split('?');
  const params: Record<string, string> = {};
  new URLSearchParams(q).forEach((v, k) => { params[k] = v; });
  return { name: ((name || 'dashboard') as RouteName), params };
}

export function toHash(r: Route): string {
  const q = new URLSearchParams(r.params).toString();
  return `#/${r.name}${q ? '?' + q : ''}`;
}
